import { useNavigate } from "react-router-dom";

export default function Header({ isLoggedIn, credits, variant = 'main' }) {
  const navigate = useNavigate();

  const renderRight = () => {
    if (variant === 'login') {
      return (
        <button onClick={() => navigate('/')}
          style={{ width: 80, fontSize: 15, fontWeight: 700, padding: '0', background: '#ffffff', color: '#111111', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, fontFamily: "'DM Mono', monospace" }}>
          ← 뒤로
        </button>
      );
    }
    if (variant === 'my') {
      return null;
    }
    if (isLoggedIn) {
      return (
        <div style={{ width: 80, display: 'flex', flexDirection: 'column', gap: 5, flexShrink: 0, height: 64 }}>
          <button onClick={() => navigate('/my')}
            style={{ fontFamily: "'DM Mono', monospace", fontSize: 15, fontWeight: 700, padding: '0', background: '#111111', color: '#ffffff', border: 'none', borderRadius: 12, cursor: 'pointer', whiteSpace: 'nowrap', flex: 1, width: '100%' }}>
            MY
          </button>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 15, fontWeight: 600, color: '#111111', background: '#f5f5f5', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', padding: '0 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, flex: 1 }}>
            💬 <span>{credits ?? '...'}개</span>
          </div>
        </div>
      );
    }
    return (
      <button onClick={() => navigate('/login')}
        style={{ width: 80, fontSize: 15, fontWeight: 700, padding: '0', background: '#ffffff', color: '#111111', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, fontFamily: "'DM Mono', monospace" }}>
        Login
      </button>
    );
  };

  if (variant === 'my') {
    return (
      <div style={{ padding: '14px 16px 0', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', marginBottom: 12, minHeight: 48 }}>
          <span style={{ fontSize: 22, fontWeight: 600, color: '#111111', letterSpacing: 1, fontFamily: "'DM Mono', monospace" }}>MY</span>
          <button onClick={() => navigate('/')}
            style={{ position: 'absolute', right: 0, width: 40, height: 40, background: '#ffffff', color: '#111111', border: '1px solid #111111', borderRadius: 8, fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Mono', monospace" }}>
            ✕
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '14px 16px 0', flexShrink: 0 }}>
      <div style={{ display: 'flex', alignItems: 'stretch', justifyContent: 'space-between', marginBottom: 12, minHeight: 64, gap: 10 }}>
        {/* 로고 PNG는 투명 배경이 아니라 흰 배경이라, invert(1) 적용 시 배경이 #000이 된다.
            박스 배경을 동일한 #000으로 맞춰야 로고가 떠 보이지 않는다. */}
        <div onClick={() => navigate('/')} style={{ background: '#000000', borderRadius: 12, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden' }}>
          <img
            src="/logo-title.png"
            alt="말투좀요"
            style={{ height: 44, filter: 'invert(1)', objectFit: 'contain', display: 'block' }}
          />
        </div>
        {renderRight()}
      </div>
      <div style={{ padding: '8px 0', borderTop: '1px solid #111111', borderBottom: '1px solid #111111', textAlign: 'center' }}>
        <span style={{ fontSize: 'clamp(11px, 3.1vw, 14px)', color: '#111111', fontWeight: 600, whiteSpace: 'nowrap' }}>
          키보드 워리어인 당신, 말투좀요가 현생을 살게해드립니다
        </span>
      </div>
    </div>
  );
}